import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './Landing.css';

import Background    from '../../assets/image/mavad avalie/23a.webp';
import BackgroundLeft from '../../assets/image/mahsolat/9e72a69f-85af-41f4-b11c-aad5cd3077f7_11zon.webp';

const SLIDES = [
    {
        imgSrc: require('../../assets/image/31_11zon.webp'),
        tag:    'مواد اولیه',
        text:   'با بهترین مواد اولیه، محصول خود را بسازید',
        btn:    'مشاهده مواد اولیه',
        link:   '/blog',
    },
    {
        imgSrc: require('../../assets/image/11_11zon.webp'),
        tag:    'محصولات برند',
        text:   'بهترین برندهای ایرانی و خارجی',
        btn:    'مشاهده محصولات',
        link:   '/landing',
    },
    {
        imgSrc:    require('../../assets/image/Clean-and-beauty-exhibition_11zon.webp'),
        tag:       'نمایشگاه زیبایی',
        text:      'نمایشگاه بین‌المللی زیبایی — جدیدترین محصولات و تکنولوژی‌های روز دنیا',
        btn:       'بیشتر بدانید',
        link:      'https://dhci.org/%DA%AF%D8%B2%D8%A7%D8%B1%D8%B4-%D8%B3%DB%8C-%D9%88-%DB%8C%DA%A9%D9%85%DB%8C%D9%86-%D9%86%D9%85%D8%A7%DB%8C%D8%B4%DA%AF%D8%A7%D9%87-%D8%A7%DB%8C%D8%B1%D8%A7%D9%86-%D8%A8%DB%8C%D9%88%D8%AA%DB%8C-%DA%A9/',
        external:  true,
    },
];

function Landing() {
    const [cur, setCur]       = useState(0);
    const [fading, setFading] = useState(false);

    useEffect(() => {
        const t = setInterval(() => {
            setFading(true);
            setTimeout(() => {
                setCur(p => (p + 1) % SLIDES.length);
                setFading(false);
            }, 400);
        }, 4000);
        return () => clearInterval(t);
    }, []);

    const goTo = (i) => {
        if (i === cur) return;
        setFading(true);
        setTimeout(() => { setCur(i); setFading(false); }, 400);
    };

    return (
        <section className="ld-section" id="ci">

            <div className="ld-grid">

                {/* ── دو کارت لینک ── */}
                <div className="ld-cards">
                    <Link to="/blog" className="ld-card">
                        <img src={Background} alt="مواد اولیه" fetchpriority="high" />
                        <div className="ld-card__overlay" />
                        <div className="ld-card__body">
                            <span className="ld-card__icon">🧪</span>
                            <h3 className="ld-card__title">مواد اولیه و بسته‌بندی</h3>
                            <span className="ld-card__btn">مشاهده ←</span>
                        </div>
                    </Link>

                    <Link to="/landing" className="ld-card">
                        <img src={BackgroundLeft} alt="محصولات" fetchpriority="high" />
                        <div className="ld-card__overlay" />
                        <div className="ld-card__body">
                            <span className="ld-card__icon">💄</span>
                            <h3 className="ld-card__title">محصولات (برند)</h3>
                            <span className="ld-card__btn">مشاهده ←</span>
                        </div>
                    </Link>
                </div>

                {/* ── اسلایدر ── */}
                <div className="ld-slider">
                    <div className={`ld-slider__img-wrap${fading ? ' ld-slider__img-wrap--fade' : ''}`}>
                        <img
                            src={SLIDES[cur].imgSrc}
                            alt={SLIDES[cur].text}
                            fetchpriority={cur === 0 ? 'high' : 'auto'}
                            loading={cur === 0 ? 'eager' : 'lazy'}
                        />
                        <div className="ld-slider__overlay" />
                    <div className="ld-slider__content">
                        <span className="ld-slider__tag">{SLIDES[cur].tag}</span>
                        <p className="ld-slider__caption">{SLIDES[cur].text}</p>
                        {SLIDES[cur].external ? (
                            <a href={SLIDES[cur].link} target="_blank" rel="noreferrer" className="ld-slider__btn">
                                {SLIDES[cur].btn} ←
                            </a>
                        ) : (
                            <Link to={SLIDES[cur].link} className="ld-slider__btn">
                                {SLIDES[cur].btn} ←
                            </Link>
                        )}
                    </div>
                    </div>

                    {/* دات‌ها */}
                    <div className="ld-dots">
                        {SLIDES.map((_, i) => (
                            <button
                                key={i}
                                className={`ld-dot${cur === i ? ' ld-dot--active' : ''}`}
                                onClick={() => goTo(i)}
                                aria-label={`اسلاید ${i + 1}`}
                            />
                        ))}
                    </div>
                </div>


            </div>
        </section>
    );
}

export default React.memo(Landing);
